const initialState = {
  categories: [],
};

export const item_reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_CATEGORY":
      return {
        ...state,
        categories: action.payload,
      };
    default:
      return state;
  }
};
